<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentLevelItem">
        <v-card-title class="text-h6 pp-center">
          Are you sure you want to delete Level "{{ currentLevelItem.name }}"?
        </v-card-title>
        <p class="pp-center pb-5">
          This level will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="levelItemLoading" />

      <ConfirmCancelButtons
          confirm-text="Delete Level"
          cancel-class="mr-5"
          :confirm-disabled="levelItemLoading"
          :item="currentLevelItem"
          :confirm-action="deleteItemConfirm"
          :cancel-action="closeDialog"/>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import { mapActions, mapGetters, mapState } from "vuex";
import UnavailableContent from "@/components/common/UnavailableContent";
import Loading from "@/components/common/Loading";

export default {
  name: "LevelDelete",
  components: {
    Loading, UnavailableContent, ConfirmCancelButtons,
  },
  computed: {
    ...mapState(['currentLevelItem']),
    ...mapGetters(['levelApiError', 'openDialog', 'currentLevelItem', 'levelItemLoading']),
    dialog: {
      get () {
        return this.openDialog === 'levelDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteLevel', 'clearLevelItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearLevelItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteLevel(this.currentLevelItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>

